/* eslint-disable camelcase  */

import {
  Alert,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TableContainer,
  TablePagination,
  TextField,
  Tooltip,
  Typography,
  Button,
  TableCell,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { toast } from 'react-toastify';
import { AgGridReact } from 'ag-grid-react';
import ModernAgGrid from '../components/ModernAgGrid';
import Scrollbar from '../components/Scrollbar';
import Page from '../components/Page';
import useAxiosWithAuth from '../api/useAxiosWithAuth';
import Iconify from '../components/Iconify';

function convertToDate(dotNetDate) {
  // Extract the number from the string
  const timestamp = parseInt(dotNetDate.replace(/\/Date\((-?\d+)\)\//, '$1'), 10);

  // Create a new Date object using the timestamp
  const date = new Date(timestamp);

  const options = {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };
  return date.toLocaleString('en-GB', options);
}

const SupplierReportRedesigned = () => {
  const [columnDefs, setColumnDefs] = useState([
    { resizable: true, field: 'ProductCode', headerName: 'Product Code', type: 'centerAligned', width: 250 },
    { resizable: true, field: 'ProductDescription', headerName: 'Product Description', width: 550 },
    // {
    //   resizable: true,
    //   field: 'AvailableQty',
    //   headerName: 'Available Quantity',
    //   width: 200,
    //   cellStyle: () => ({
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //   }),
    // },
    {
      resizable: true,
      field: 'QtyOnHand',
      headerName: 'Quantity at Hand',
      width: 200,
      cellStyle: () => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }),
    },
    {
      resizable: true,
      field: 'Sales',
      headerName: 'Completed Sales',
      cellRenderer: (params) => params.data.Sales ?? 'N/A',
      cellStyle: () => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }),
      width: 200,
    },
    {
      resizable: false,
      field: '',
      headerName: 'Action',
      pinned: 'right',
      width: 200,
      cellRenderer: (params) => (
        <span style={{ padding: 2 }}>
          <Tooltip title="Update Product Code">
            <IconButton aria-label="delete" onClick={() => handleClickOpenDialog(params.data)}>
              <Iconify icon={'tabler:edit'} width={22} height={22} />
            </IconButton>
          </Tooltip>
          <Tooltip title="View Batch Details">
            <IconButton aria-label="delete" onClick={() => handleClickOpenBatchDialog(params.data)}>
              <Iconify icon={'grommet-icons:view'} width={22} height={22} />
            </IconButton>
          </Tooltip>
        </span>
      ),
    },
  ]);

  const { post, put, get } = useAxiosWithAuth();
  const [stockReport, setStockReport] = useState([]);

  const maxDate = new Date().toISOString().split('T')[0];

  const date = new Date().toISOString().slice(0, 7);
  // const firstDayOfCurrentMonth = new Date(date.getFullYear(), date.getMonth(), 1, 12);
  // const lastDayOfCurrentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0, 12);

  // const formattedFirstDate = firstDayOfCurrentMonth.toISOString().slice(0, 10);
  // const formattedLastDate = lastDayOfCurrentMonth.toISOString().slice(0, 10);

  const [reportDate, setReportDate] = useState(date);
  const [reportEndDate, setReportEndDate] = useState(date);
  const [isLoading, setIsLoading] = useState(true);
  const [isBatchLoading, setIsBatchLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);

  const loadingMessages = [
    'Fetching product details...',
    'Gathering sales data...',
    'Calculating quantity at hand...',
    'Preparing your report...',
    'Almost ready...',
  ];

  const [selectedProductCode, setSelectedProductCode] = useState('');
  const [currentProductCode, setCurrentProductCode] = useState('');

  const [warehouseCodes, setWarehouseCodes] = useState([]);
  const [selectedWarehouses, setSelectedWarehouses] = useState([]);
  const [appliedWarehouses, setAppliedWarehouses] = useState([]);

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openBatchDialog, setOpenBatchDialog] = React.useState(false);

  const [batchInfo, setBatchInfo] = React.useState([]);
  const [batchError, setBatchError] = React.useState(false);
  const [batchLoadingMessageIndex, setBatchLoadingMessageIndex] = useState(0);

  const batchLoadingMessages = [
    'Fetching batch information...',
    'Retrieving warehouse data...',
    'Checking expiry dates...',
    'Compiling batch details...',
  ];

  const handleClickOpenDialog = (data) => {
    setSelectedProductCode(data.ProductCode);
    setCurrentProductCode(data.ProductCode);
    setOpenDialog(true);
  };

  const handleClickOpenBatchDialog = (data) => {
    setSelectedProductCode(data.ProductCode);
    setCurrentProductCode(data.ProductCode);
    setOpenBatchDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleBatchCloseDialog = () => {
    setOpenBatchDialog(false);
  };

  const onUpdate = async () => {
    setIsLoading(true);
    try {
      const res = await put(`/product/update-product-code`, {
        old_code: currentProductCode,
        new_code: selectedProductCode,
      });
      if (res.status === 200) {
        toast.success('Product code updated successfully');
      }
    } catch (err) {
      console.log(err);
      toast.warn('Product code updated failed');
    } finally {
      setIsLoading(false);
      setOpenDialog(false);
      setShouldRefresh(true);
    }
  };

  // Function to convert JSON data to CSV and initiate download
  const exportStockReportCSV = async (post, user) => {
    try {
      // Call the API to get all records
      const response = await post(
        `product/export-stock-report-for-supplier/${user['http://healthhouse.com/supplier_code']}?page_size=9999999&page_number=1`,
        {}
      );

      const data = response.data.payload;

      if (!data || data.length === 0) {
        console.log('No data to export');
        return;
      }

      // Define CSV headers based on the fields in the data
      const headers = [
        'Product Code',
        'Product Description',
        'Available Quantity',
        'Quantity On Hand',
        'Batch Number',
        'Batch Expiry',
        'Batch Quantity',
        'Warehouse Code',
      ];

      // Convert data to CSV format
      const csvContent = [
        headers.join(','),
        ...data.map((item) =>
          [
            `"${(item.ProductCode || '').replace(/"/g, '""')}"`,
            `"${(item.ProductDescription || '').replace(/"/g, '""')}"`,
            item.AvailableQty || '',
            item.QtyOnHand || '',
            `"${(item.BatchNumber || '').replace(/"/g, '""')}"`,
            item.BatchExpiry || '',
            item.BatchQuantity || '',
            `"${(item.WarehouseCode || '').replace(/"/g, '""')}"`,
          ]
            .map((field) => (typeof field === 'string' && field.includes(',') ? `"${field}"` : field))
            .join(',')
        ),
      ].join('\n');

      // Create a Blob with the CSV content
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      // Create a link element to trigger the download
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute(
        'download',
        `stock_report_${user['http://healthhouse.com/supplier_code']}_${new Date().toISOString().slice(0, 10)}.csv`
      );
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting CSV:', error);
    }
  };

  const { user } = useAuth0();

  // Fetch warehouse codes for the current supplier
  useEffect(() => {
    const fetchWarehouseCodes = async () => {
      try {
        const res = await post(
          `product/warehouses-codes-for-supplier/${encodeURIComponent(user['http://healthhouse.com/supplier_code'])}`,
          {}
        );
        const codes = res.data.payload || [];
        setWarehouseCodes(codes);
        setSelectedWarehouses(codes); // select all by default
        setAppliedWarehouses(codes);
      } catch (err) {
        console.log(err);
      }
    };

    if (user?.['http://healthhouse.com/supplier_code']) {
      fetchWarehouseCodes();
    }
  }, [user]);

  // Effect to cycle through loading messages
  useEffect(() => {
    if (isLoading) {
      const messageInterval = setInterval(() => {
        setLoadingMessageIndex((prevIndex) => {
          // Cycle through messages, loop back to start if needed
          return (prevIndex + 1) % loadingMessages.length;
        });
      }, 60000); // Change message every 60 seconds (1 minute)

      return () => clearInterval(messageInterval);
    }
    setLoadingMessageIndex(0); // Reset when loading completes
  }, [isLoading]);

  useEffect(() => {
    const getReport = async () => {
      setIsLoading(true);
      const date = new Date(reportDate);
      const firstDayOfCurrentMonth = new Date(date.getFullYear(), date.getMonth(), 1, 12);
      const lastDayOfCurrentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0, 12);

      const formattedFirstDate = firstDayOfCurrentMonth.toISOString().slice(0, 10);
      const formattedLastDate = lastDayOfCurrentMonth.toISOString().slice(0, 10);
      const payload = {
        start_date: formattedFirstDate,
        end_date: formattedLastDate,
        warehouse_codes: appliedWarehouses,
      };
      try {
        const res = await post(
          `product/stock-report-for-supplier/${
            user['http://healthhouse.com/supplier_code']
          }?page_size=${rowsPerPage}&page_number=${page + 1}`,
          payload
        );
        setStockReport(res.data.payload);
        setTotal(res.data.meta.total_size);
        setStockReport(res.data.payload);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      } finally {
        setShouldRefresh(false);
      }
    };

    getReport();
  }, [reportDate, reportEndDate, page, rowsPerPage, user, shouldRefresh, appliedWarehouses]);

  useEffect(() => {
    const batchInfo = async () => {
      setIsBatchLoading(true);
      setBatchError(false);
      try {
        const res = await get(`batch/batches-by-sku/${encodeURIComponent(selectedProductCode)}`);
        if (res.data && res.data.payload) {
          setBatchInfo(res.data.payload);
        } else {
          setBatchInfo([]);
          setBatchError(true);
        }
        setBatchInfo(res.data.payload);
        setIsBatchLoading(false);
      } catch (err) {
        console.log(err);
        setBatchInfo([]);
        setBatchError(true);
        setIsBatchLoading(false);
      } finally {
        setIsBatchLoading(false);
      }
    };

    batchInfo();
  }, [user, selectedProductCode]);

  // Effect to cycle through batch loading messages
  useEffect(() => {
    if (isBatchLoading) {
      const messageInterval = setInterval(() => {
        setBatchLoadingMessageIndex((prevIndex) => {
          return (prevIndex + 1) % batchLoadingMessages.length;
        });
      }, 60000); // Change message every 60 seconds

      return () => clearInterval(messageInterval);
    }
    setBatchLoadingMessageIndex(0); // Reset when loading completes
  }, [isBatchLoading]);

  const paginationNumberFormatter = useCallback((params) => {
    return `[${params.value.toLocaleString()}]`;
  }, []);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Page title="Stock Report">
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2} ml={2}>
          <Typography variant="h4" gutterBottom>
            Supplier's Report
          </Typography>
          <Stack direction={'row'} gap={2}>
            <Button variant="contained" onClick={() => exportStockReportCSV(post, user)}>
              Export CSV
            </Button>
            {/* <TextField
              label="Start Date"
              type="month"
              value={reportDate.slice(0, 7)}
              variant="outlined"
              onChange={(e) => {
                const selectedDate = new Date(e.target.value);
                const firstDayOfSelectedMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1);
                const formattedDate = firstDayOfSelectedMonth.toISOString().slice(0, 10);
                setReportDate(formattedDate);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              disabled={reportDate === new Date().toISOString().slice(0, 10)}
              label="End Date"
              type="month"
              value={reportEndDate.slice(0, 7)}
              variant="outlined"
              onChange={(e) => {
                const selectedDate = new Date(e.target.value);
                const lastDayOfSelectedMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
                const formattedDate = lastDayOfSelectedMonth.toISOString().slice(0, 10);
                setReportEndDate(formattedDate);
              }}
              inputProps={{
                max: maxDate,
                min: reportDate,
              }}
            /> */}
            <TextField
              label="Select Month"
              type="month"
              value={reportDate}
              variant="outlined"
              onChange={(e) => {
                setReportDate(e.target.value);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Stack>
        </Stack>
        <Alert sx={{ my: 2 }} severity="info">
          Selected month will only affect the <strong>Units sold</strong> column.
        </Alert>
        <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={1} sx={{ mb: 2 }}>
          <FormControl sx={{ minWidth: 220 }} size="small">
            <InputLabel id="warehouses-label">Warehouses</InputLabel>
            <Select
              labelId="warehouses-label"
              multiple
              value={selectedWarehouses}
              onChange={(e) => setSelectedWarehouses(e.target.value)}
              input={<OutlinedInput label="Warehouses" />}
              renderValue={(selected) => selected.join(', ')}
            >
              {warehouseCodes.map((code) => (
                <MenuItem key={code} value={code}>
                  <Checkbox checked={selectedWarehouses.indexOf(code) > -1} />
                  <ListItemText primary={code} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              setAppliedWarehouses(selectedWarehouses);
              setPage(0);
            }}
          >
            Filter
          </Button>
        </Stack>
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, maxHeight: 550, p: 3 }}>
              <div className="ag-theme-material" style={{ height: 500, minWidth: 750 }}>
                {isLoading ? (
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <CircularProgress size={72} sx={{ mb: 3 }} />
                    <h5>{loadingMessages[loadingMessageIndex]}</h5>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                      This may take a few minutes. Please wait...
                    </Typography>
                  </div>
                ) : (
                  <ModernAgGrid rowData={stockReport} columnDefs={columnDefs} style={{ height: 520, minWidth: 750 }} />
                )}
              </div>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {/* <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, p: 3 }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Product</TableCell>
                    <TableCell align="center">Product Description</TableCell>
                    <TableCell align="center">Qty on Hand</TableCell>
                    <TableCell align="center">Available Quantity</TableCell>
                    <TableCell align="center">Units Sold</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stockReport?.map((item, index) => (
                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell align="left">{item?.ProductCode}</TableCell>
                      <TableCell align="center">{item?.ProductDescription}</TableCell>
                      <TableCell align="center">{item?.QtyOnHand}</TableCell>
                      <TableCell align="center">{item?.AvailableQty}</TableCell>
                      <TableCell align="center">{item?.QtyOnHand - item?.AvailableQty}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card> */}
      </Container>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Update Product Code?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please be absolutely sure before changing the product code. This action might cause issues.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="productCode"
            label="New Product Code"
            type="text"
            fullWidth
            variant="standard"
            value={selectedProductCode}
            onChange={(e) => setSelectedProductCode(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={onUpdate}>Update</Button>
        </DialogActions>
      </Dialog>
      {/* batch dialog */}
      <Dialog maxWidth={'xl'} open={openBatchDialog} onClose={handleBatchCloseDialog}>
        <DialogTitle>Batch Details</DialogTitle>
        <DialogContent>
          {isBatchLoading && (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <CircularProgress size={72} sx={{ mb: 3 }} />
              <h5>{batchLoadingMessages[batchLoadingMessageIndex]}</h5>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Please wait...
              </Typography>
            </div>
          )}
          {!isBatchLoading && batchError && (
            <div
              style={{
                width: '100%',
                height: '200px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Iconify icon={'mdi:alert-circle-outline'} width={64} height={64} color="#FFA48D" />
              <Typography variant="h6" sx={{ mt: 2, color: 'text.secondary' }}>
                No Batch Data Found
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                No batch records found for this product.
              </Typography>
            </div>
          )}
          {!isBatchLoading && !batchError && batchInfo?.length === 0 && (
            <div
              style={{
                width: '100%',
                height: '200px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Iconify icon={'mdi:database-remove-outline'} width={64} height={64} color="#919EAB" />
              <Typography variant="h6" sx={{ mt: 2, color: 'text.secondary' }}>
                No Data Available
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                No batch records found for this product.
              </Typography>
            </div>
          )}
          {!isBatchLoading && !batchError && batchInfo?.length > 0 && (
            <TableContainer sx={{ minWidth: 800 }}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Batch</TableCell>
                    <TableCell align="center">Expiry Date</TableCell>
                    <TableCell align="center">Quantity</TableCell>
                    <TableCell align="right">Warehouse Code</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Active warehouses */}
                  {batchInfo
                    .filter((item) => appliedWarehouses.includes(item?.WarehouseCode))
                    .map((item, index) => (
                      <TableRow key={`active-${index}`} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell align="left">{item?.Number}</TableCell>
                        <TableCell align="center">{convertToDate(item?.ExpiryDate)}</TableCell>
                        <TableCell align="center">{item?.Quantity}</TableCell>
                        <TableCell align="right">{item?.WarehouseCode}</TableCell>
                      </TableRow>
                    ))}

                  {/* Divider row — only shown if there are inactive items */}
                  {batchInfo.some((item) => !appliedWarehouses.includes(item?.WarehouseCode)) && (
                    <TableRow>
                      <TableCell colSpan={4} sx={{ py: 0.5, bgcolor: 'grey.100' }}>
                        <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>
                          Inactive warehouses (not in current filter)
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}

                  {/* Inactive warehouses */}
                  {batchInfo
                    .filter((item) => !appliedWarehouses.includes(item?.WarehouseCode))
                    .map((item, index) => (
                      <TableRow
                        key={`inactive-${index}`}
                        sx={{ opacity: 0.45, bgcolor: 'grey.50', '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell align="left" sx={{ color: 'text.disabled' }}>
                          {item?.Number}
                        </TableCell>
                        <TableCell align="center" sx={{ color: 'text.disabled' }}>
                          {convertToDate(item?.ExpiryDate)}
                        </TableCell>
                        <TableCell align="center" sx={{ color: 'text.disabled' }}>
                          {item?.Quantity}
                        </TableCell>
                        <TableCell align="right" sx={{ color: 'text.disabled' }}>
                          {item?.WarehouseCode}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBatchCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
};

export default SupplierReportRedesigned;
